import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { ContactUsViewV2 } from 'views/rebranded-module/information-module/ContactUsViewV2';
import { HydrationWrapper } from 'views/common/components';
import { API } from 'lib/config/axios';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { useContactUsCMSData } from 'views/rebranded-module/information-module/ContactUsViewV2/hooks/useContactUsCMSData';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { getDeviceType } from 'lib/utils/getDeviceType';

const ContactUsPage = (props) => {
  const content = useContactUsCMSData();
  const { serverData, deviceType } = props;
  return (
    <HydrationWrapper>
      <ContentContext.Provider value={content?.data}>
        <ContactUsViewV2 deviceType={deviceType} serverData={serverData} />
      </ContentContext.Provider>
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const {
    locale, req, res, pathname,
  } = ctx;

  const ssrRender = isCrawlers(req.headers['user-agent']);
  const deviceType = getDeviceType(req.headers['user-agent']);

  let serverData = null;
  let layoutData = null;
  let serverError = null;

  if (ssrRender && pathname != '/_error') {
    const [layoutRes, contactUsPageData] = await Promise.all([
      serverFetch(ctx, API.layout),
      serverFetch(ctx, API.contactUs),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
    } else {
      res.statusCode = 503;
      throw new Error('Rendering halted because we failed to load layout data');
    }
    if (contactUsPageData.success && contactUsPageData.data) {
      serverData = contactUsPageData.data;
    } else {
      serverError = {
        statusCode: contactUsPageData?.error?.response?.status,
      };
    }
  }
  if (serverError) {
    ctx.res.statusCode = serverError.statusCode;
  }
  const hreflangData = generateHreflang(PATHS.contactUs().url, locale);
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'contact_us_V2_page',
        'common_new_main_widget',
        'common_main_widget_dialog_v2',
      ])),
      hreflangData,
      serverData,
      layoutData,
      ssrRender,
      serverError,
      deviceType,
      rebrandingPage: true,
      options: {
        transparentNavBar: true,
      },
    },
  };
}
export default ContactUsPage;
